import React from "react";
import { FaCalendarAlt, FaSuitcase } from "react-icons/fa";
import "../../assets/style/Qualification.css";
import { useTranslation } from "react-i18next";

const Experience: React.FC = () => {
  const { t } = useTranslation("fr", { useSuspense: false });
  return (
    <div className="experience">
      <h3 className="qualification__title">
        <FaSuitcase size={20} /> {t("experience.experienceTitle")}
      </h3>
      <div className="timeline__item">
        <div className="circle__dot"></div>
        <h3 className="timeline__title">
          {t("experience.freelanceLuxiryInbox")}
        </h3>
        <p className="timeline__text">
          {t("experience.freelanceLuxiryInboxDescription")}
        </p>
        <span className="timeline__date">
          <FaCalendarAlt size={15} />
          {t("experience.freelanceLuxiryInboxDate")}
        </span>
      </div>
      <div className="timeline__item">
        <div className="circle__dot"></div>
        <h3 className="timeline__title">
          {t("experience.frontendDeveloperAtTwenIT")}
        </h3>
        <p className="timeline__text">
          {t("experience.frontendDeveloperAtTwenITDescription")}
        </p>
        <span className="timeline__date">
          <FaCalendarAlt size={15} />
          {t("experience.frontendDeveloperAtTwenITDate")}
        </span>
      </div>
      <div className="timeline__item">
        <div className="circle__dot"></div>
        <h3 className="timeline__title">
          {t("experience.miniMemoireProjectTitle")}
        </h3>
        <p className="timeline__text">
          {t("experience.miniMemoireProjectDescription")}
        </p>
        <span className="timeline__date">
          <FaCalendarAlt size={15} />
          {t("experience.miniMemoireProjectDate")}
        </span>
      </div>

      <div className="timeline__item">
        <div className="circle__dot"></div>
        <h3 className="timeline__title">
          {t("experience.internshipAtTwenIT")}
        </h3>
        <p className="timeline__text">
          {t("experience.internshipAtTwenITDescription")}
        </p>
        <span className="timeline__date">
          <FaCalendarAlt size={15} />
          {t("experience.internshipAtTwenITDate")}
        </span>
      </div>
      <div className="timeline">
        <div className="timeline__item">
          <div className="circle__dot"></div>
          <h3 className="timeline__title">
            {t("experience.webCupParticipation")}
          </h3>
          <p className="timeline__text">
            {t("experience.webCupParticipationDescription")}
          </p>
          <span className="timeline__date">
            <FaCalendarAlt size={15} />
            {t("experience.webCupParticipationDate")}
          </span>
        </div>

        <div className="timeline__item">
          <div className="circle__dot"></div>
          <h3 className="timeline__title">
            {t("experience.internshipAtRANConsulting")}
          </h3>
          <p className="timeline__text">
            {t("experience.internshipAtRANConsultingDescription")}
          </p>
          <span className="timeline__date">
            <FaCalendarAlt size={15} />
            {t("experience.internshipAtRANConsultingDate")}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Experience;
